export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/coupon.016effc0-c93b2c.png";